import React from 'react';

import { styled } from '@mui/material/styles';

import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from 'clsx';
const PREFIX = 'MainLayout';

const classes = {
    root: `${PREFIX}-root`,
    content: `${PREFIX}-content`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        height: '100%',
    },

    [`& .${classes.content}`]: {
        height: '100%'
    }
}));

const MainLayout = props => {


    return (
        <Root className={clsx({
            [classes.root]: true
        })}>
            <main className={classes.content}>
                <Outlet />
            </main>
        </Root>
    );
}

MainLayout.propTypes = {
    children: PropTypes.node
};

export default MainLayout;